<template>
  <div>
    <!-- done appointment list -->
    <bill-appointments-list
      :listTitle="'selectAppointments'"
      :billAppointmentsFullList="items"
      :selectedBillAppointments="billAppointments"
      @selectedbillappointmentsupdated="setSelectedBillAppointments"
      ><slot slot="filters" name="filters"></slot
    ></bill-appointments-list>
    <!-- lower buttons -->
    <v-row class="no-gutters justify-space-between">
      <v-col class="col-12 col-sm-auto mb-3">
        <v-tooltip right content-class="portal-tooltip-inverted">
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              color="primary"
              class="caption font-weight-bold"
              outlined
              rounded
              block
              @click="goToAcceptedAppointments"
              >{{ $t("billAppointments.otherAppointments") }}</v-btn
            >
          </template>
          <span>{{ $t("billAppointments.otherAppointmentstooltip") }}</span>
        </v-tooltip>
      </v-col>
      <v-col class="col-12 col-sm-auto mb-3">
        <v-btn
          color="primary"
          class="caption font-weight-bold"
          :disabled="!hasBillAppointments"
          depressed
          rounded
          block
          @click="submit"
          >{{ $t("billAppointments.addToBill") }}</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BillAppointmentsList from "./BillAppointmentsList";

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    contentType: {
      type: String,
      required: true
    }
  },
  components: {
    BillAppointmentsList
  },
  data() {
    return {
      content: {
        new: {
          initialize: this.initializeNewBill,
          acceptedAppointmentsRouteName: "_billNewAcceptedAppointmentList"
        },
        edit: {
          initialize: this.initializeEditBill,
          acceptedAppointmentsRouteName: "_billEditAcceptedAppointmentList"
        }
      },
      billAppointments: [],
      parentRouteName: "_billDetails"
    };
  },
  created() {
    this.content[this.contentType].initialize();
  },
  computed: {
    bill: {
      get() {
        return this.$store.getters["bills/activeBill"];
      },
      set(value) {
        //
      }
    },
    billId() {
      return this.$route.params.id;
    },
    hasBillAppointments() {
      return this.billAppointments.length > 0;
    }
  },
  methods: {
    initializeNewBill() {
      this.bill = null;
    },
    async initializeEditBill() {
      if (this.bill !== null && this.bill.id === this.billId) {
        this.$store.commit("billAppointments/SET_PAGE_DESC_PARAMS", {
          billProtocolCode: this.bill.protocolCode
        });
      } else {
        if (this.bill) {
          await this.$store.dispatch("bills/getBill");
          this.$store.commit("billAppointments/SET_PAGE_DESC_PARAMS", {
            billProtocolCode: this.bill.protocolCode
          });
        }
      }
    },
    setSelectedBillAppointments(selectedBillAppointments) {
      this.billAppointments = selectedBillAppointments;
    },
    async submit() {
      if (this.bill) {
        await this.markAppointmentsAsDoneAndAddToBill();
      } else {
        await this.$store.dispatch("bills/createBill");
        await this.markAppointmentsAsDoneAndAddToBill();
      }
    },
    async markAppointmentsAsDoneAndAddToBill() {
      for (let appointment of this.billAppointments) {
        await this.markAppointmentAsDoneAndAddToBill(appointment);
        await this.addProvidedServiceToBill(appointment);
      }
      await this.reloadBillAndProvidedServices();
      this.goToBillPage();
    },
    async markAppointmentAsDoneAndAddToBill(appointment) {
      await this.$store.dispatch(
        "billAppointments/addDoneAppointment",
        appointment.appointmentId
      );
    },
    async addProvidedServiceToBill(appointment) {
      await this.$store.dispatch(
        "bills/addProvidedServiceToBill",
        appointment,
        { root: true }
      );
    },
    async reloadBillAndProvidedServices() {
      await this.$store.dispatch("bills/reloadBillAndProvidedServices", null, {
        root: true
      });
    },
    goToAcceptedAppointments() {
      this.$router.push({
        name: this.content[this.contentType].acceptedAppointmentsRouteName
      });
    },
    goToBillPage() {
      this.$router.push({
        name: this.parentRouteName,
        params: { id: this.bill.id }
      });
    }
  }
};
</script>
